import { HttpClient } from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, filter, map} from 'rxjs/operators';
import {CommonTranslationService, ITranslationResource} from './common-translation.service';
import {ShellDomainProvider} from '../utility/shell-domain.provider';


export class MultiTranslateHttpLoader implements TranslateLoader {
    langArray: any[] = [];
    lastLanguage: any;
    commonLanguage: any;

    constructor(
        private http: HttpClient,
        private resources: ITranslationResource[]
    ) {
    }

    public getTranslation(lang: string): Observable<any> {
        const commonPrefix = ShellDomainProvider['api'].DefaultPackagePath;
        const commonSuffix = ShellDomainProvider['api'].DefaultSuffix;

        if (CommonTranslationService.lastLanguage !== lang) {
            CommonTranslationService.translation = undefined;
        }

        CommonTranslationService.lastLanguage = lang;

        if (CommonTranslationService.translation) {
            this.resources.filter(item => {
                return item.prefix !== commonPrefix;
            });
        } else {
            const filterResource = this.resources.filter(item => {
                return item.prefix === commonPrefix;
            });

            if (filterResource.length === 0) {
                this.resources.push({
                    prefix: commonPrefix,
                    suffix: commonSuffix === null || commonSuffix === undefined ? '.json' : commonSuffix
                });
            }
        }

        const requests = this.resources.map(resource => {
            const path = resource.prefix + lang + resource.suffix;
            return this.http.get(path, {withCredentials: true}).pipe(
                catchError(res => {
                    console.error('Could not find translation file:', path);
                    return of({});
                })
            );
        });

        return forkJoin(requests).pipe(
            filter((response:any) => response && response.length ? response : []),
            map((response: any) => {
                const commonIndex = this.resources.findIndex(r => r.prefix === commonPrefix);
                let mergedResources = {};

                for(let resourceObj of response){
                  mergedResources = this.mergeDeep(resourceObj, mergedResources)
                }

                if (commonIndex > -1) {
                    CommonTranslationService.translation = response[commonIndex];
                }
                const mergedSourceResources = CommonTranslationService.translation ? CommonTranslationService.translation : {};
                const allMergedResources = Object.assign(mergedResources, mergedSourceResources);

                return allMergedResources;
            })
        );
    }

    mergeDeep(target:any, source:any) {
        if (typeof target === 'object' && typeof source === 'object') {
            Object.keys(source).forEach(key => {
                if (source[key] === null && (target[key] === undefined || target[key] === null)) {
                    target[key] = null;
                } else if (source[key] instanceof Array) {
                    if (!target[key]) {
                        target[key] = [];
                    }
                    // concatenate arrays
                    target[key] = target[key].concat(source[key]);
                } else if (typeof source[key] === 'object') {
                    if (!target[key]) {
                        target[key] = {};
                    }
                    this.mergeDeep(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            });
        }
        return target;
    }
}
